import React from "react";
import { Box, Button, Grid, Paper, useTheme, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

function ControlBar(props) {
  const { Button1, ButtonLink, Button2, Button2Function, helpHint } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Changed to 'sm' for better mobile detection

  return (
    <Paper sx={{ 
      mb: { xs: 0, sm: 0 }, 
      p: { xs: 1.5, sm: 2, md: 2.5 },
      boxShadow: { xs: 0, sm: 1 },
      borderRadius: { xs: 0, sm: 2 },
      width: '100%',
      boxSizing: 'border-box',
      backgroundColor: 'background.paper',
      borderBottom: { xs: '1px solid', sm: 'none' },
      borderBottomColor: { xs: 'divider', sm: 'transparent' }
    }}>
      <Box 
        sx={{ 
          display: 'flex',
          flexDirection: 'row',
          justifyContent: { xs: 'space-between', sm: 'flex-start' }, // Full spread on mobile, normal on larger screens
          alignItems: 'center',
          width: '100%',
          gap: { xs: 1, sm: 2 }
        }}
      >
        {Button1 && (
          <Button
            component={Link}
            to={ButtonLink}
            variant="contained"
            size={isMobile ? "small" : "medium"}
            id="control-button-1"
            startIcon={<AddIcon />}
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.875rem', md: '1rem' },
              py: { xs: 0.75, sm: 1, md: 1.5 },
              px: { xs: 1.5, sm: 2, md: 3 },
              minWidth: { xs: 'auto', sm: '120px', md: '140px' },
              whiteSpace: 'nowrap'
            }}
          >
            {Button1}
          </Button>
        )}

        {Button2 && (
          <Button
            id="control-button-2"
            variant="outlined"
            size={isMobile ? "small" : "medium"}
            onClick={Button2Function}
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.875rem', md: '1rem' },
              py: { xs: 0.75, sm: 1, md: 1.5 },
              px: { xs: 1.5, sm: 2, md: 3 },
              minWidth: { xs: 'auto', sm: '80px', md: '100px' },
              whiteSpace: 'nowrap',
              ml: { xs: 'auto', sm: 2 } // Push to far right on mobile, normal spacing on larger screens
            }}
          >
            {Button2}
          </Button>
        )}
        {helpHint && (
          <Box sx={{ ml: { xs: 0, sm: 'auto' }, display: 'flex', alignItems: 'center' }}>
            {helpHint}
          </Box>
        )}
      </Box>
    </Paper>
  );
}

ControlBar.defaultProps = {
  Button2: "",
};

export default ControlBar;
